var map = {
	"./vi/common/audit-log.js": 30321,
	"./vi/common/button.js": 53625,
	"./vi/common/common.js": 19580,
	"./vi/common/controls.js": 36095,
	"./vi/common/date.js": 65309,
	"./vi/common/enum.js": 97428,
	"./vi/common/error-message.js": 31009,
	"./vi/common/google-drive.js": 25159,
	"./vi/common/navigation.js": 15555,
	"./vi/common/newsfeed.js": 9498,
	"./vi/common/notify-message.js": 26642,
	"./vi/common/notify.js": 46968,
	"./vi/common/support.js": 4646,
	"./vi/common/tour-guide.js": 7758,
	"./vi/common/user.js": 37170,
	"./vi/common/validate.js": 79983,
	"./vi/student/account.js": 63948,
	"./vi/student/change-password.js": 50377,
	"./vi/student/class-room.js": 75799,
	"./vi/student/course-detail.js": 52130,
	"./vi/student/course.js": 84550,
	"./vi/student/dashboard.js": 42483,
	"./vi/student/document.js": 10866,
	"./vi/student/examination.js": 42974,
	"./vi/student/exercise-refer.js": 73038,
	"./vi/student/exercise.js": 69461,
	"./vi/student/galactic-warrior-game.js": 99763,
	"./vi/student/lesson-note.js": 71768,
	"./vi/student/meeting.js": 66938,
	"./vi/student/storage-exercise.js": 58721,
	"./vi/student/student-classroom.js": 17917,
	"./vi/student/student.js": 69288,
	"./vi/student/teacher.js": 93153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55197;